import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

import { InsuranceProviders } from '../../../../../../enums/insurance-providers';
import HelpArticleLink from '../../../../../../components/help-article-link';
import { InsuranceTermsLink } from '../../../../../../insurance/terms-link';
import { BASE_SHIPMENTS_PATH } from '../../../../../../routes/constants';
import { linkIDs } from '../../../../../../services/link-service/links';
import { insurancePromoCardMessages } from './messages';
import styles from './insurance-promo-card.module.less';

type InsurancePromoCardProps = {
  insuranceProviderId: string;
};

export const InsurancePromoCard = ({ insuranceProviderId }: InsurancePromoCardProps) => {
  const claimLinkId =
    insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId ? linkIDs.FileXCoverClaim : linkIDs.FileParcelGuardClaim;

  return (
    <div className={styles['promo-card']}>
      <FlexColumn>
        <Text className={styles['promo-headline']} textType={TextType.Paragraph} value={insurancePromoCardMessages.headline} />
        <Text className={styles['promo-body']} textType={TextType.Paragraph} value={insurancePromoCardMessages.body} />
        <FlexRow className={styles['promo-links']} gap={Gap.Space24}>
          <InsuranceTermsLink insuranceProviderId={insuranceProviderId}>
            <Text textType={TextType.Paragraph} value={insurancePromoCardMessages.learnMoreLink} />
            <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
          </InsuranceTermsLink>
          <Link to={BASE_SHIPMENTS_PATH}>
            <Text textType={TextType.Paragraph} value={insurancePromoCardMessages.seeInsuredShipmentsLink} />
            <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
          </Link>
          <HelpArticleLink articleId={claimLinkId}>
            <Text textType={TextType.Paragraph} value={insurancePromoCardMessages.fileClaimLink} />
            <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
          </HelpArticleLink>
        </FlexRow>
      </FlexColumn>
    </div>
  );
};
